<template>
  <div class="editor scroll-vertical">
    <detail-item
      name="Tags"
      imgName="circle">
      <div class="tags">
        <span
          v-for="tag in item.parsed.match.tags"
          :key="tag"
          class="tag is-rounded is-clickable"
          @click="$store.commit(`${storeName}/ADD_FILTER`, `tag:${tag}`)">
          {{ tag }}
        </span>
      </div>
    </detail-item>
    <detail-item
      name="Actions"
      imgName="circle">
      <div class="tags">
        <span
          v-for="action in item.parsed.match.actions"
          :key="action"
          class="tag is-rounded is-clickable"
          @click="$store.commit(`${storeName}/ADD_FILTER`, `action:${action}`)">
          {{ action }}
        </span>
      </div>
    </detail-item>
    <detail-item
      v-for="item in item.parsed.match.context"
      :key="item.name"
      :name="item.name"
      imgName="circle">
      {{ item.value }}
    </detail-item>
  </div>
</template>

<script>
import DetailItem from '@/components/DetailItem.vue';

export default {
  name: 'AlertLogDetails',
  components: {
    DetailItem,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    storeName() {
      if (Object.prototype.hasOwnProperty.call(this.item, 'log')) {
        return 'logViewState';
      }
      return 'alertViewState';
    },
  },
};
</script>

<style lang="scss" scoped>
.tags {
  .tag {
    background-color: #789;
  }
}
</style>
